import MainLayoutComponent from './MainLayoutComponent';
export default MainLayoutComponent;
